"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeyIssueCard = exports.KeyIssueCardDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_title_1 = require("./entity-title");
var content_1 = require("../elements/content");
var section_label_1 = require("../elements/section-label");
var use_lang_1 = require("../../hooks/use-lang");
var use_entities_1 = require("../../hooks/use-entities");
var use_icons_1 = require("../../hooks/use-icons");
var entity_reference_1 = require("./entity-reference");
var entity_link_1 = require("./entity-link");
var entity_cell_header_1 = require("./entity-cell-header");
exports.KeyIssueCardDefaultProps = {
  showTitle: true,
  showDescription: true
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n    display: flex;\n    flex-direction: column;\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n  "], ["\n    padding: ", ";\n    display: flex;\n    flex-direction: column;\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n  "])), theme_1.theme.UNIT(4))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " 0;\n  "], ["\n    padding: ", " 0;\n  "])), theme_1.theme.UNIT(4))
});
var SectionLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  \n    color: ", ";\n  "], ["\n  \n    color: ", ";\n  "])), theme_1.theme.COLOR('dark'))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var InfluencingFactorsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(8))
});
var InfluencingFactorStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n    padding: ", " 0;\n    background-position: bottom left;\n  "], ["\n    ", ";\n    padding: ", " 0;\n    background-position: bottom left;\n  "])), theme_1.theme.DOT_BG('h', 'line-mid', 2, 4), theme_1.theme.UNIT(2))
});
var InfluencingFactorListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), theme_1.theme.DOT_BG('h', 'line-mid', 2, 4))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(0))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(1))
});
// -------- Components -------->
var My = {
  SectionLabel: (0, styled_components_1.default)(section_label_1.SectionLabel)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), SectionLabelStyles),
  InfluencingFactors: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), InfluencingFactorsStyles),
  InfluencingFactorList: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), InfluencingFactorListStyles),
  InfluencingFactor: (0, styled_components_1.default)(entity_reference_1.EntityReference)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), InfluencingFactorStyles),
  Container: (0, styled_components_1.default)(entity_link_1.EntityLink)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Label: (0, styled_components_1.default)(entity_cell_header_1.EntityCellHeader)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Title: (0, styled_components_1.default)(entity_title_1.EntityTitle)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Body: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Description: (0, styled_components_1.default)(content_1.Content)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
var KeyIssueCard = function (props) {
  var className = props.className,
    entity = props.entity,
    showTitle = props.showTitle,
    showDescription = props.showDescription;
  var description = entity.description,
    _a = entity.influencingFactorsOutgoing,
    influencingFactorsOutgoing = _a === void 0 ? [] : _a,
    _b = entity.influencingFactorsIncoming,
    influencingFactorsIncoming = _b === void 0 ? [] : _b;
  var t = (0, use_lang_1.useLang)();
  var entities = (0, use_entities_1.useEntities)();
  var Icons = (0, use_icons_1.useIcons)();
  var hasDescription = description && description.html;
  var influencingFactors = influencingFactorsOutgoing.concat(influencingFactorsIncoming);
  return react_1.default.createElement(My.Container, {
    entity: entity,
    className: className
  }, react_1.default.createElement(My.Header, null, react_1.default.createElement(My.Label, {
    entity: entity
  }), showTitle && react_1.default.createElement(My.Title, {
    entity: entity
  })), react_1.default.createElement(My.Body, null, showDescription && hasDescription && react_1.default.createElement(My.Description, {
    verySmall: true,
    html: description.html
  }), !!influencingFactors.length && react_1.default.createElement(My.InfluencingFactors, null, react_1.default.createElement(My.SectionLabel, null, entities.InfluencingFactor.pluralLabel, ":"), react_1.default.createElement(My.InfluencingFactorList, null, influencingFactors.map(function (influencingFactor) {
    return react_1.default.createElement(My.InfluencingFactor, {
      key: influencingFactor.id,
      entity: influencingFactor
    });
  })))));
};
exports.KeyIssueCard = KeyIssueCard;
exports.KeyIssueCard.defaultProps = exports.KeyIssueCardDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;